import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';
import { Switch } from 'antd';
import Authorize from 'components/Providers/Authorize';
import PageWrapper from 'components/Shared/Page/Wrapper';
import PageTitle from 'components/Shared/Page/Title';
import withPusher from 'components/Providers/Pusher/withPusher';
import PageBanners from 'components/Layout/PageBanners';
import useTranslation from 'utils/hooks/useTranslation';
import EdenredBanner from './EdenredBanner';
import WalletEmptyState from './WalletEmptyState';
import WalletDashboard from './Dashboard/index';

const Wallet = ({ history }) => {
  const { translateText } = useTranslation();

  // TEMPORARY: lets us flip between the empty state and the funded dashboard
  // until "create a wallet" functionality exists. Remove this toggle then.
  const [showDashboard, setShowDashboard] = useState(true);

  return (
    <Authorize>
      <Helmet title="Wallet" />
      <PageBanners />
      <PageWrapper history={history} loading={false}>
        <PageTitle
          title={translateText('corporateAccounts.menuLeft.wallet')}
          description={translateText('corporateAccounts.wallet.description')}
        />
        <div className="card-body">
          {/* TEMPORARY dev toggle — remove once wallet creation is implemented. */}
          <div
            style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}
            data-testid="walletStateToggle"
          >
            <Switch checked={showDashboard} onChange={setShowDashboard} size="small" />
            <span>
              {showDashboard
                ? 'TEMPORARY dev toggle Showing: Dashboard'
                : 'TEMPORARY dev toggle Showing: Empty state'}
            </span>
          </div>

          <EdenredBanner />
          {showDashboard ? <WalletDashboard /> : <WalletEmptyState />}
        </div>
      </PageWrapper>
    </Authorize>
  );
};

export default withPusher(injectIntl(Wallet));
